var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.201 15.661a1.5 1.5 0 0 1 .55-2.049l2.192-1.266a.5.5 0 0 1 .5.867L6.25 14.478a.5.5 0 0 0-.183.683l1.266 2.193a.677.677 0 0 0 .925.248l5.098-2.943a.677.677 0 0 0 .247-.926l-1.765-3.058.866-.5 1.765 3.058a1.677 1.677 0 0 1-.613 2.292l-5.098 2.943a1.677 1.677 0 0 1-2.291-.614L5.201 15.66Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 11.46a1.677 1.677 0 0 1 .613-2.292l5.098-2.943a1.677 1.677 0 0 1 2.29.614l1.267 2.192a1.5 1.5 0 0 1-.55 2.05l-2.192 1.265a.5.5 0 0 1-.5-.866l2.192-1.266a.5.5 0 0 0 .183-.683L16.936 7.34a.677.677 0 0 0-.925-.248l-5.098 2.943a.677.677 0 0 0-.248.925l1.766 3.059-.866.5-1.766-3.059Z",
    fill: "currentColor"
  })));
};
export { SvgLink as ReactComponent };
export default __webpack_public_path__ + "e3eb392a2d7500b6006c3aade2cda9b2.svg";